<app-input
  [control]="control"
  [label]="label"
  [secondaryLabel]="secondaryLabel"
  [placeholder]="placeholder"
  [id]="id"
  [errorMessage]="errorMessage"
  [inputClass]="inputClass"
  [labelClass]="labelClass"
  [decimal]="true"
  [showSuffix]="true"
>
  <span suffix class="text-grey-500">%</span>
</app-input>
